module.exports = __webpack_public_path__ + "media/images/countryrect/ba-07e408667d56183a5278b1efc1287c57.svg";